import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type Organization = 'energifabriken' | 'vegoil';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {
  private currentOrganization$ = new BehaviorSubject<Organization | null>(
    (localStorage.getItem('organization') as Organization) || null
  );

  constructor() {
    // Listen to changes and persist to localStorage
    this.currentOrganization$.subscribe(org => {
      if (org) {
        localStorage.setItem('organization', org);
      } else {
        localStorage.removeItem('organization');
      }
    });
  }

  getCurrentOrganization(): Organization | null {
    return this.currentOrganization$.getValue();
  }

  setOrganization(org: Organization) {
    this.currentOrganization$.next(org);
  }

  getApiPrefix(): string {
    const org = this.getCurrentOrganization();
    return org === 'vegoil' ? '/appapivegmatrix' : '/appapi';
  }

  getHubUrl(): string {
    const org = this.getCurrentOrganization();
    return org === 'vegoil' ? '/apphubvegmatrix' : '/apphub';
  }

  getOrganizationName(): string {
    const org = this.getCurrentOrganization();
    return org === 'vegoil' ? 'Vegoil' : 'Energifabriken';
  }

  clearOrganization() {
    this.currentOrganization$.next(null);
  }
}

